import { observer } from 'mobx-react';
import { Component } from 'react';
import { ORDERS_GROUPS, ORDERS_TYPES_GROUP, ORDER_STATUS, ORDER_TYPE } from 'src/constants/order';
import { localeStore } from 'src/mobx/localesStore';
import Button from 'src/view/components/Controls/ButtonComponent/Button';
import { OrderStore } from '~/mobx/orderStore';
import logger from '~/services/logger';
import { withOrderStore } from '~/view/screens/OrderScreen/context';
import './style.scss';

// @ts-ignore
@withOrderStore
@observer
export default class OrderCompleteButton extends Component<{ orderStore?: OrderStore }> {
  get orderStore() {
    return this.props.orderStore!;
  }

  completeOrder = async () => {
    if (!this.orderStore.order) {
      return;
    }
    try {
      await this.orderStore.changeStatus(this.orderStore.order.id, ORDER_STATUS.COMPLETED);
    } catch (error: any) {
      logger.error({ error, place: 'OrderCompleteButton', showModal: true });
    }
  };

  get isUnavailableComplete(): boolean {
    const { order, loading } = this.orderStore;
    return !order || (!loading && ORDERS_TYPES_GROUP[ORDER_TYPE.HISTORY][ORDERS_GROUPS.ALL].includes(order.order_status_code));
  }

  render() {
    if (this.isUnavailableComplete) return null;

    return (
      <div className="btn-complete">
        <Button
          title={localeStore.t('complete_button')}
          onClick={this.completeOrder}
          loading={this.orderStore.loading}
          appearance="primary"
          size="large"
          stretched
        />
      </div>
    );
  }
}
